'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { fadeInUp, scaleIn, staggerContainer, viewportOnce } from '@/lib/animations';

export default function Product() {
  const t = useTranslations('Product');

  const stats = [
    { key: 'stat_users', labelKey: 'stat_users_label' },
    { key: 'stat_volume', labelKey: 'stat_volume_label' },
    { key: 'stat_growth', labelKey: 'stat_growth_label' },
    { key: 'stat_countries', labelKey: 'stat_countries_label' },
  ];

  return (
    <section id="products-kuik" className="w-full bg-white py-8 px-6 sm:px-10 lg:px-16">
      <div className="max-w-8xl mx-auto">
        <motion.div
           style={{backgroundImage: "url('/images/homepage/kuik_bg.png')"}}
           className="relative bg-cover overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-16 text-white shadow-xl grid grid-cols-1 lg:grid-cols-12 gap-10 items-center"
           initial="hidden"
           whileInView="visible"
           viewport={viewportOnce}
           variants={scaleIn}
        >

          <motion.div className="lg:col-span-7 space-y-6 z-10" variants={staggerContainer(0.1, 0.2)}>
            <motion.span variants={fadeInUp} className="text-[10px] sm:text-xs font-bold tracking-widest text-blue-200 uppercase block">
              {t('badge')}
            </motion.span>

            <motion.h2 variants={fadeInUp} className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.12]">
              {t('heading')}
            </motion.h2>

            <motion.p variants={fadeInUp} className="text-xs sm:text-sm text-blue-100/90 font-normal leading-relaxed max-w-2xl">
              {t('description')}
            </motion.p>

            <motion.ul variants={staggerContainer(0.08)} className="space-y-2 pt-2">
              {stats.map((stat) => (
                <motion.li variants={fadeInUp} key={stat.key} className="flex items-center gap-2.5 text-xs sm:text-sm font-bold text-white">
                  <span className="w-1.5 h-1.5 rounded-full bg-white block" />
                  <span>{t(stat.labelKey)}</span>
                </motion.li>
              ))}
            </motion.ul>

            <motion.div variants={fadeInUp} className="pt-4">
              <Link
                href="https://www.kuik.al"
                target='_blank'
                className="inline-flex items-center justify-center gap-2 bg-white text-blue-700 hover:bg-blue-50 font-bold text-xs sm:text-sm px-6 py-3.5 rounded-xl transition-all shadow-md group"
              >
                <span>{t('cta_button')}</span>
                <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}